import Component_EngineView_ecf2432aee3de7a75830157bb781a857 from "../../../../content/examples/basic/engine-view/EngineView";
import Devtool_EngineView_ecf2432aee3de7a75830157bb781a857 from "!!@devtool/loader!../../../../content/examples/basic/engine-view/EngineView";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_EngineView_ecf2432aee3de7a75830157bb781a857,
  Devtool_EngineView_ecf2432aee3de7a75830157bb781a857,
  DevTool,
  React
};